// overlayKit/Stamp.tsx — rotated framed callout (regulators, CTAs, document seals).
// Migrated from ChocolateFullPreview inline Stamp. No Sequence wrapper needed.
import React from "react";
import { useCurrentFrame, useVideoConfig, interpolate, spring } from "remotion";
import { FONT, TS, win } from "./utils";
import { useColor } from "./palette";

export type StampProps = {
  title: string;
  sub?: string;
  atS: number;
  outS: number;
  /** Palette token (default "secondary"). */
  color?: string;
};

export const Stamp: React.FC<StampProps> = ({ title, sub, atS, outS, color = "secondary" }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const t = frame / fps;
  const op = win(t, atS, outS);
  if (op <= 0.001) return null;
  const sc = spring({ frame: Math.max(0, frame - Math.round(atS * fps)), fps, config: { damping: 9, stiffness: 130 } });
  const rot = interpolate(t, [atS, atS + 0.35], [-13, -5], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const hex = useColor(color);
  return (
    <div style={{ position: "absolute", top: 18, left: 22, fontFamily: FONT, opacity: op }}>
      <div style={{ transform: `rotate(${rot}deg) scale(${sc})`, transformOrigin: "left top", display: "inline-block", border: `4px solid ${hex}`, padding: "22px 48px", color: hex, boxShadow: `0 0 28px ${hex}44, 0 8px 26px rgba(0,0,0,0.7)`, textAlign: "left" }}>
        <div style={{ fontSize: 52, fontWeight: 900, letterSpacing: "0.07em", textShadow: TS }}>{title}</div>
        {sub && <div style={{ fontSize: 19, marginTop: 7, letterSpacing: "0.2em", textShadow: TS }}>{sub}</div>}
      </div>
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
